var _circle, _path, _path2, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLogo2(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 2281,
    height: 2281,
    viewBox: "0 0 2281 2281",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 1140.5,
    cy: 1140.5,
    r: 1140.5,
    fill: "white"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_3961_51994",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 458,
    y: 695,
    width: 1366,
    height: 1003
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M458 695H1824V1698H458V695Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_3961_51994)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask1_3961_51994",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 460,
    y: 695,
    width: 1363,
    height: 1002
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1822.11 1129.28V1696.44C1801.76 1696.48 1781.56 1694.71 1761.54 1691.07C1741.57 1687.47 1722.13 1682.09 1703.3 1674.99C1684.47 1667.88 1666.59 1659.12 1649.61 1648.76C1632.67 1638.45 1616.97 1626.7 1602.55 1613.53C1588.14 1600.35 1575.28 1586.01 1563.95 1570.53C1552.61 1555.02 1543.08 1538.68 1535.3 1521.47C1527.52 1504.22 1521.64 1486.5 1517.65 1468.21C1513.72 1449.96 1511.77 1431.5 1511.77 1412.86V881.28C1511.82 842.49 1501.01 806.387 1479.33 773.014C1457.7 739.641 1428.25 713.637 1391.01 695H1676.02C1695.42 695 1714.06 698.381 1731.95 705.142C1749.83 711.903 1765.62 721.568 1779.33 734.094C1793.04 746.619 1803.61 761.052 1811.01 777.391C1818.41 793.774 1822.11 810.764 1822.11 828.491V1129.28ZM744.963 695C764.314 695 782.955 698.381 800.883 705.142C818.765 711.903 834.559 721.568 848.267 734.094C861.974 746.619 872.504 761.052 879.95 777.391C887.349 793.774 891.049 810.764 891.049 828.491V1454.42C870.654 1454.42 850.496 1452.6 830.528 1448.96C810.512 1445.36 791.113 1439.95 772.283 1432.84C753.453 1425.73 735.572 1416.98 718.639 1406.62C701.706 1396.3 686.007 1384.51 671.588 1371.38C657.216 1358.21 644.315 1343.86 633.027 1328.39C621.691 1312.91 612.11 1296.57 604.331 1279.37C596.553 1262.16 590.624 1244.44 586.687 1226.15C582.703 1207.9 580.711 1189.48 580.711 1170.84V880.197C580.521 841.58 569.612 805.737 547.984 772.537C526.355 739.381 497.043 713.55 460 695H744.963ZM925.531 695H1210.54C1229.89 695 1248.53 698.381 1266.41 705.142C1284.3 711.946 1300.09 721.568 1313.8 734.094C1327.5 746.619 1338.03 761.052 1345.43 777.391C1352.88 793.774 1356.58 810.807 1356.58 828.491V1575.47C1336.18 1575.47 1315.98 1573.65 1296.01 1570.06C1276 1566.42 1256.6 1561.04 1237.77 1553.93C1218.94 1546.78 1201.06 1538.07 1184.07 1527.71C1167.14 1517.35 1151.44 1505.61 1137.02 1492.43C1122.65 1479.26 1109.75 1464.95 1098.46 1449.44C1087.13 1433.97 1077.59 1417.63 1069.77 1400.38C1061.99 1383.17 1056.11 1365.44 1052.12 1347.15C1048.19 1328.91 1046.19 1310.44 1046.24 1291.85V881.28C1046.24 842.49 1035.43 806.387 1013.8 773.014C992.171 739.641 962.764 713.637 925.531 695Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_3961_51994)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M460 695H1822.11V1696.44H460V695Z",
    fill: "black"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo2);
export default __webpack_public_path__ + "static/media/logo 2.d616c37b73a0676027f401fa7b197b70.svg";
export { ForwardRef as ReactComponent };